import type {IApplicationDefinition} from '@apps-config/app-definition'
import type {History} from 'history'

import {Application as ServicePerformanceApplication} from '@applications/service-performance'
import {Application as YourProductsAndServices} from '@applications/your-products-and-services'
import {
  performanceReducer,
  ServicePerformanceAction,
} from '@telstra-connect/service-performance/reducers'

import {loadFeatureFlags as loadMPFFeatureFlags} from '@telstra-connect/service-performance/feature-flags/load-flags'
import {platformAppName} from '@telstra-connect/utils/data/platform-data'
import {servicesPerAppName} from '@telstra-connect/utils/data/service-performance'
import {ApplicationName as ServicePerformanceAppName} from '@telstra-connect/service-performance/activity-tracking'
import type {IFeatureFlags as IDashboardFlags} from '@telstra-connect/dashboard/feature-flags/common'
import type {IServicePerformanceState} from '@telstra-connect/service-performance/state'
import type {IFeatureFlags as ServicePerformanceFlags} from '@telstra-connect/service-performance/feature-flags/common'
import {setFeatureFlags} from '@apps-config/feature-flags'
import '../node_modules/telstra-ui/resources/telstraui.css'
import '../node_modules/telstra-ui/resources/themes/pacific.css'
import '../node_modules/ted-ui/build/style-without-able.css'

import {enableLogging} from '@utils/logger'

enableLogging()

loadMPFFeatureFlags()

export function getPlatformFlagName(platformFlagName: string) {
  // eslint-disable-next-line dot-notation, @typescript-eslint/dot-notation
  const servicesConfig = window['applications']
  if (servicesConfig == null) {
    return false
  }
  if (
    typeof servicesConfig[platformAppName] === 'object' &&
    servicesConfig[platformAppName][platformFlagName]
  ) {
    return servicesConfig[platformAppName][platformFlagName]
  }
  return false
}

export function getServicePerformanceFlagName(platformFlagName: string) {
  // eslint-disable-next-line dot-notation, @typescript-eslint/dot-notation
  const servicesConfig = window['applications']
  if (servicesConfig == null) {
    return false
  }
  if (
    typeof servicesConfig[platformAppName] === 'object' &&
    servicesConfig[platformAppName].yourServicesInternational
  ) {
    return getPlatformFlagName(platformFlagName)
  } else {
    if (servicesConfig == null) {
      return false
    }
    if (
      typeof servicesConfig[servicesPerAppName] === 'object' &&
      servicesConfig[servicesPerAppName][platformFlagName]
    ) {
      return servicesConfig[servicesPerAppName][platformFlagName]
    }
    return false
  }
}

export interface IGlobalMapProps {
  width?: number | string
  height?: number | string
  className?: string
}

function getServicePerformanceApplication() {
  setFeatureFlags()
  return ServicePerformanceApplication
}
function getYourProductsAndServices() {
  setFeatureFlags()
  return YourProductsAndServices
}

function getServicePerformanceReducer() {
  return (performanceReducer as unknown) as IServicePerformanceState
}

type TGetSessionDetails = () => {sessionId: string}

interface IApplications {
  [platformAppName]?: IDashboardFlags
  [ServicePerformanceAppName]?: ServicePerformanceFlags
  ['Billing']?: object
}

declare const global: {
  TCONN: {
    getAppRoutingHistory: () => History
    getSessionDetails: TGetSessionDetails
    Platform: {
      isSecureAuth: boolean;
      resolveTargetURL: (targetURL: string) => string;
    }
    ServicePerformance: {
      GetApplication: () => IApplicationDefinition
      GetReducers: (
        state: IServicePerformanceState,
        action: ServicePerformanceAction,
      ) => IServicePerformanceState
    }
    YourProductsAndServices: {
      GetApplication: () => IApplicationDefinition
      GetReducers: (
        state: IServicePerformanceState,
        action: ServicePerformanceAction,
      ) => IServicePerformanceState
    }
  }
  applications: IApplications
}

global.TCONN = {...global.TCONN}

global.TCONN.ServicePerformance = {
  GetApplication: getServicePerformanceApplication,
  GetReducers: getServicePerformanceReducer,
}

global.TCONN.YourProductsAndServices = {
  GetApplication: getYourProductsAndServices,
  GetReducers: getServicePerformanceReducer,
}

export default global
